module.exports = "<section class=\"gw-box gw-gateway-page\">\r\n    <h1>{{'portal.index.Preferences' | translate }}</h1>\r\n    <div class=\"gw-control-group\">\r\n        <label class=\"gw-control-label\">{{'gateway.views.preferences.languages' | translate }}</label>\r\n        <div ng-if=\"!visible\">{{currentLocaleDisplayName}}</div>\r\n        <div gw-pl-language-select class=\"gw-vertical-align-item\"></div>\r\n    </div>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/preferences.html
// module id = 818
// module chunks = 0